export default __webpack_public_path__ + "static/business-167992039dd2928123a26c7839b6ef0c.webp";